import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { useAuthStore } from '/src/stores/authStore';
import './assets/variables.css'
import './assets/admin-ui.css'
import { installMobileCardTableLabels } from './utils/mobileCardTables'

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
const authStore = useAuthStore();
authStore.loadTokensFromStorage();
authStore.initializeSession();

app.use(router)
installMobileCardTableLabels(app)
app.mount('#app')
